@if (integration(); as i) {
    <p-card class="integration-card" (click)="openCard()">
        @let active = i.integration?.status === "active";
        @let needsReauth = i.integration?.status === "active" && i.integration?.authStatus === "invalid";
        @let isRateLimited = active && i.integration?.authStatus === "rate-limited";

        @if (i.devStatus === "alpha") {
            <span class="integration-state alpha-state" pTooltip="{{ 'set_int_alpha_tooltip' | translate }}">ALPHA</span>
        } @else if (i.devStatus === "beta") {
            <span class="integration-state beta-state" pTooltip="{{ 'set_int_beta_tooltip' | translate }}">BETA</span>
        } @else if (i.devStatus === "new") {
            <span class="integration-state new-state">{{ "set_int_card_badge_new" | translate }}</span>
        }

        <div class="w-full flex flex-row items-start gap-4">
            <img [src]="`/assets/images/integrations/logos/${i.serviceId}.webp`" [alt]="(`${i18nPrefix}.name` | translate) + ' logo'" class="logo" />
            <h5 class="m-0 min-w-0 self-center text-lg!">
                {{ `${i18nPrefix}.name` | translate }}
                @if (needsReauth) {
                    <span class="active-state reauth" pTooltip="{{ 'set_int_reauth_tooltip' | translate }}"></span>
                } @else if (isRateLimited) {
                    <span class="active-state rate-limited" pTooltip="{{ 'set_int_rate_limited_tooltip' | translate }}"></span>
                } @else if (active) {
                    <span class="active-state active" pTooltip="{{ 'set_int_active_tooltip' | translate }}"></span>
                }
            </h5>
        </div>
        <div class="description">
            {{ `${i18nPrefix}.card_description` | translate }}
        </div>

        @if (needsReauth) {
            <div class="absolute left-0 bottom-0 max-md:static h-10">
                <p-tag
                    class="h-10"
                    [value]="'set_int_needs_reauth' | translate"
                    [style]="{ fontSize: '0.9rem', width: '18rem' }"
                    icon="pi pi-exclamation-triangle"
                    severity="warn"
                >
                </p-tag>
            </div>
        }
    </p-card>
}
